import React from 'react';
import WName, {WArticle} from '../WName';
import Eon, {EonArticle} from '../Eon';
import PL from '../problems/ProblemLink';
import QL from '../faq/QuestionLink';
import LRL from '../longreads/LongReadLink';
import OML from '../ormaybe/OrMaybeLink';
import AL from './AngleLink';
import NW from '../neologisms/NewWord';
import {E1, E2, TLDR} from '../common';

// Everything is (or can be) a 'story'.
export const story = {
  name: "story",
  alternatives: "stories",
  prelude: <span>
    There are <PL name="non-finite">infinite</PL> ways for a <AL name="religion.jain.kevala">केवलिन् (kevalin)</AL> to <LRL>understand</LRL> <AL name="religion.jain.anekantavada">अनेकान्तवाद (anekāntavāda)</AL>.
  </span>,
  header: <span>
    Everything is a ‘story’.
  </span>,
  outside: <span>
    <TLDR />: <NW>cogitamus ergo sumus</NW>, ∴ (<QL name="silly">bowling-ball symbol</QL>) not <NW>APE</NW> but <QL>consciousness</QL> (cf. <WName />) is foremost.<sup>†</sup> Stories are merely one way for <QL>consciousness</QL> to <LRL>understand</LRL> <PL>ourself</PL>.
  </span>,
  headerFootnote: <span>
    † Existence precedes absence, frankly, not the other way around. That’s both from QM/quantum mechanics (‘<LRL name="reality">virtual</LRL>’ particles) and <AL name="fields.logic.">IBK</AL>’s axiom of शून्यता (śūnyatā: voidness, or of <PL>non-finite</PL> <AL>potential</AL>).
  </span>,
  preview: <div className="angle-preview">
    <p><WName /> has <OML name="unity">unified</OML> QM and GR – the ‘holy grail’ of <PL name="all.time">2020’s</PL> <AL name="fields.">physics</AL> – not with <AL name="fields.">maths</AL> but through a <QL>metaphor</QL> of <AL>Ken</AL> (and Barbie, and a ‘<QL name="languages">biblioteca</QL>’).</p>
  </div>,
  text: <div className="angle-text">
    <p>[Under construction, if the <OML name="offensive">eejit</OML> <NW>zyzzyvas</NW> ever make <i><QL>time</QL></i> for it.]</p>
  </div>,
};

